import React from "react";
import CustomModal from "../../common/CustomModal";
import AdRequestCreate from "../AdRequestCreate";

// Reuses the create form in edit mode. `request` is the ad-request detail object.
const EditAdRequestModal = ({ open, onClose, request }) => (
  <CustomModal
    open={open}
    title="Edit ad request"
    onClose={onClose}
    isButtonsRequired={false}
    bodyClassName="bg-[#f7f7fb]"
    className="md:!w-[92%] lg:!w-[80%] xl:!w-[1040px]"
  >
    {request ? (
      <AdRequestCreate
        key={request.id}
        editRequest={request}
        onSuccess={onClose}
      />
    ) : null}
  </CustomModal>
);

export default EditAdRequestModal;
